module.exports = __webpack_public_path__ + "static/media/Mask1.e59bbebb.png";